module.exports = __webpack_public_path__ + "img/ceuta.6ec6aa4c.svg";